const webApi = "https://www.guohongdl.com/";
// const webApi = "http://124.71.59.200/";
export default {
  webApi
};



// WEBPACK FOOTER //
// ./src/utils/webApi.js